/** Remove tudo que não for dígito */
export function apenasDigitos(valor: string): string {
  return valor.replace(/\D/g, "");
}

/** Formata telefone para exibição: (99) 99999-9999 ou (99) 9999-9999 */
export function formatarTelefone(valor: string): string {
  const n = apenasDigitos(valor);
  if (n.length === 11) return `(${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7)}`;
  if (n.length === 10) return `(${n.slice(0, 2)}) ${n.slice(2, 6)}-${n.slice(6)}`;
  return valor;
}

/** Aplica máscara enquanto o usuário digita: (99) 99999-9999 */
export function mascaraTelefone(valor: string): string {
  const n = apenasDigitos(valor).slice(0, 11);
  if (n.length === 0) return "";
  if (n.length <= 2) return `(${n}`;
  if (n.length <= 6) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
  if (n.length <= 10) return `(${n.slice(0, 2)}) ${n.slice(2, 6)}-${n.slice(6)}`;
  return `(${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7)}`;
}

/** Formata CPF para exibição: 999.999.999-99 */
export function formatarCPF(valor: string): string {
  const n = apenasDigitos(valor);
  if (n.length !== 11) return valor;
  return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9)}`;
}

/** Aplica máscara de CPF enquanto o usuário digita */
export function mascaraCPF(valor: string): string {
  const n = apenasDigitos(valor).slice(0, 11);
  if (n.length <= 3) return n;
  if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`;
  if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
  return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9)}`;
}
